import { useState, useRef, useEffect } from "react";
import { useTheme } from "../hooks/useTheme";
import { useAnimation } from "../hooks/useAnimation";
import "./SettingsDropdown.css";

export function SettingsDropdown() {
  const [open, setOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();
  const { animationState, toggleAnimation } = useAnimation();
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    };
    window.addEventListener("mousedown", close);
    return () => window.removeEventListener("mousedown", close);
  }, [open]);

  return (
    <div className="settings" ref={ref}>
      <button
        type="button"
        className="settings__trigger"
        aria-label="Open settings"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3h0a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5h0a1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8v0a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z" />
        </svg>
      </button>
      {open && (
        <div className="settings__panel" role="menu">
          <button type="button" className="settings__item" onClick={toggleTheme} role="menuitem">
            <span>Theme</span>
            <span className="settings__value">{theme === "dark" ? "Dark" : "Light"}</span>
          </button>
          <button type="button" className="settings__item" onClick={toggleAnimation} role="menuitem">
            <span>Animation</span>
            <span className="settings__value">{animationState === "on" ? "On" : "Off"}</span>
          </button>
        </div>
      )}
    </div>
  );
}
